import api from '@/api'
// 供应商 储备池
const state = {
  class1List: [],
  supplyCityList: [],
  jobShopList: [ {id: 1, text: '是'}, {id: 2, text: '否'} ], // 是否具备加工车间
  supplierStatus: [ {id: 1, text: '待认领'}, {id: 2, text: '已认领'}, {id: 3, text: '未匹配'}, {id: 4, text: '已入驻'} ],
  deliveryTypeList: [ {id: 1, text: '晨采'}, {id: 2, text: '预采'}, {id: 3, text: '晨采+预采'} ],
  carTypeList: [ {active: false, id: 1, text: '敞篷货车'}, {active: false, id: 2, text: '箱式货车'}, {active: false, id: 3, text: '保温箱货'}, {active: false, id: 4, text: '冷藏箱货'}, {active: false, id: 5, text: '其他'} ],
  companyTypeList: [
    // {id: 2, text: '内部供应商(美菜内部子公司)'},
    {id: 7, text: '批发商'},
    {id: 21, text: '厂商/品牌方(含种植户、养殖户、基地供应商、合作社)'},
    {id: 22, text: '个体户'},
    {id: 23, text: '授权代理商'}
  ],
  submitData: { // 最终要提交的数据 = 基本信息 + 主营信息 + 兼营信息
    supplierPoolCategoryList: [] // 兼营信息
  }
}

const mutations = {
  setSupplyCityList (state, data) {
    // data && data.unshift({ 'id': 99999, 'name': '其它' })
    state.supplyCityList = data
  },
  setClass1 (state, data) {
    state.class1List = data
  },
  setSubmitData (state, data) {
    state.submitData = data
  },
  resetSubmitData (state, data) {
    state.submitData = {
      supplierPoolCategoryList: []
    }
  },
  setBaseInfoSubmitData (state, data) {
    Object.assign(state.submitData, data)
  },
  setSideInfo (state, data) { // 保存兼营信息
    if (!data.pageIndex) {
      Object.assign(state.submitData, data)
    }
    state.submitData.supplierPoolCategoryList.splice(data.pageIndex, 1, data)
  }
}
const actions = {
  // 获取一级分类
  getClass1 ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getClass1InSupplierPool(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resData.data && resData.data.map(item => {
            item.text = item.name
          })
          commit('setClass1', resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierPool/getClass1', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierPool/getClass1', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取二级分类
  getClass2 ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getClass2InSupplierPool(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierPool/getClass2', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierPool/getClass2', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 提交储备池信息
  submitSupplierInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.submitSupplierInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierPool/submitSupplierInfo', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierPool/submitSupplierInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getSupplyCitys ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listBizCity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setSupplyCityList', resData.data)
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/public/listWithWarehouseByCity', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/public/listWithWarehouseByCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  changeBaseInfoSubmitData ({ commit }, data) {
    commit('setBaseInfoSubmitData', data)
  },
  changeSubmitDataInfo ({commit}, data) {
    commit('setSideInfo', data)
  },
  changeResetSubmitData ({commit}, data) {
    commit('resetSubmitData', data)
  }
  // checkCacheSupplierPool ({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     const supplierPoolInfo = localStorage.getItem('supplierPoolInfo')
  //     console.log('缓存中的信息', supplierPoolInfo)
  //     if (supplierPoolInfo) {
  //       commit('setSubmitData', JSON.parse(supplierPoolInfo))
  //       resolve(true)
  //     } else {
  //       resolve(false)
  //     }
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/supplierPool.js